import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { Clock, ArrowRight } from "lucide-react";

export default function PendingBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isCadastroPending = user?.activation_status === "pending_review";
  const isUpgradePending = user?.upgrade_status === "pending_review";
  const isUpgradeAwaiting = user?.upgrade_status === "awaiting_payment";
  const visible = !!user && (isCadastroPending || isUpgradePending || isUpgradeAwaiting);

  useEffect(() => {
    if (visible) {
      document.body.style.paddingTop = "2.75rem";
      return () => { document.body.style.paddingTop = ""; };
    }
    return undefined;
  }, [visible]);

  if (!visible) return null;

  const label = isUpgradePending
    ? `Upgrade em análise — ${user.requested_plan_label || "novo plano"}`
    : isUpgradeAwaiting
      ? `Ativação pendente — pague o PIX de R$ 39,90`
      : "Cadastro em análise pelo administrador";

  const cta = isUpgradeAwaiting ? "Pagar PIX" : "Ver status";

  return (
    <div
      className="fixed top-16 inset-x-0 z-40 border-b border-amber-500/40 bg-amber-500/10 backdrop-blur"
      data-testid="pending-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-11 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-amber-600 dark:text-amber-400 min-w-0">
          <Clock className="h-4 w-4 shrink-0" />
          <span className="truncate">
            <b>{label}.</b>{" "}
            <span className="hidden sm:inline text-muted-foreground">
              A ativação é automática após a confirmação do pagamento.
            </span>
          </span>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={() => navigate("/aguardando-ativacao")}
          data-testid="pending-banner-cta"
          className="shrink-0"
        >
          {cta} <ArrowRight className="h-3 w-3 ml-2" />
        </Button>
      </div>
    </div>
  );
}
